<template lang="pug">
  div.lmm-content-body-padded
    b-container(fluid)
      b-row
        b-col.page-wrap(cols="12")
          div.page-header(slot="header")
            b-container.d-flex.justify-content-between(fluid, v-if="!AppState.isStandalone", style="padding-left: 0")
              div
                span.page-title {{$t('service')}} {{$t('registration')}} / {{$t('update')}}
                b-button(style="padding: 0.25rem 0.7rem;", variant="link", size="sm", target="_blank", href="https://www.tosspayments.com/faq")
                  span {{$t('tutorial-license')}}
              div
                b-btn(v-if="AppState.license !== 'Free'", size="sm", @click="addLicense") {{$t('add_n', {v: $t('license')})}}
                div(v-else) {{$t('free_trial_comment')}}
          b-card.table-card
            b-table.license-table(
              :fields="fields",
              :items="items",
              tbody-class="lmm-table-body")
              template(slot="HEAD_pay_expire", slot-scope="data") {{$t('end_time')}}
              template(slot="HEAD_pay_pay_type", slot-scope="data") {{$t('payment_type')}}
              template(slot="HEAD_pay_dev_vol", slot-scope="data") {{$t('device_vol')}}
              template(slot="HEAD_period", slot-scope="data") {{$t('remain')}}
              template(slot="HEAD_update", slot-scope="data") {{$t('renew')}}
              template(v-slot:cell(pay_expire)="row")
                | {{row.item.pay_expire | moment('add', AppState.Info.timezoneOffset, AppState.Info.dateFmt)}}
              template(v-slot:cell(period)="row")
                template(v-if="row.item.isExpired") {{$t('expire')}}
                template(v-else) {{row.item.pay_expire | moment('from', today, true)}}
              template(v-slot:cell(pay_type)="row")
                | {{$t(row.item.pay_type)}}
              template(v-slot:cell(update)="row")
                b-btn.update-license-btn(size="sm", @click="updateLicense(row.item)")
                  span {{$t('renew')}}
    b-modal(
      size="lg",
      v-model="payment.show",
      header-class="lmm-common-popup-header",
      no-close-on-backdrop)
      template.align-items-center(slot="modal-header")
        div
          h3.text-center {{$t(payment.title)}}
      div.d-flex.align-items-center.justify-content-center.mb-3.header-desc-div
        span 라이선스 유형 변경 및 장기 약정 희망시 고객 센터로 문의 바랍니다.
      div
        b-table.modal-table(
          :fields="payment.fields",
          :items="payment.items",
          tbody-class="lmm-table-body",
          outlined)
          template(slot="HEAD_start_date", slot-scope="data") {{$t('start_time')}}
          template(slot="HEAD_expire_date", slot-scope="data") {{$t('end_time')}}
          template(slot="HEAD_type", slot-scope="data") {{$t('device_type')}}
          template(slot="HEAD_vol", slot-scope="data") {{$t('device_vol')}}
          template(slot="HEAD_period", slot-scope="data") {{$t('period')}}
          template(slot="HEAD_total", slot-scope="data") {{$t('total_price')}}
          template(v-slot:cell(start_date)="row") {{row.item.start_date | moment(AppState.Info.dateFmt)}}
          template(v-slot:cell(expire_date)="row") {{row.item.expire_date | moment(AppState.Info.dateFmt)}}
          template(v-slot:cell(type)="row")
            template(v-if="useCustom") {{customPaymentName}}
            template(v-else-if="row.item.first")
              b-form-select(v-model="row.item.type", :options="[{value:'Corporate', text:$t('Corporate')},{value:'Basic', text:$t('Basic')}]", size="sm", @input="calcTotal")
            template(v-else) {{$t(row.item.type)}}
          template(v-slot:cell(vol)="row")
            template(v-if="row.item.ref && !row.item.first") {{row.item.vol}}
            template(v-else)
              b-form-input.text-right(v-model="row.item.vol", size="sm", @input="calcTotal")
          template(v-slot:cell(period)="row")
            b-form-select(v-model="row.item.period", :options="periods", size="sm", @input="calcTotal")
          template(v-slot:cell(total)="row")
            span.discount(v-if="payment.discount > 0") {{payment.fullPay | comma}} {{$t('WON')}}
            span.price {{payment.total | comma}} {{$t('WON')}}
        //p.desc-1.text-center(v-html="$t('payment_tax_desc1')")
        //p.desc-2
        //  h4.text-center
        //    //- icon(name="info-circle", scale="1.4")
        //    span(v-html="$t('payment_tax_desc2')")
        //  p.text-center(v-html="$t('payment_tax_desc2')")
        //  p.text-center(v-html="$t('payment_tax_desc3')")
        div(v-if="payment.title === 'regist_service'" ).d-flex.justify-content-center.flex-column.align-items-center.desc-div
          span(style="margin-top:2.5rem") {{$t('payment_tax_desc1')}}
          span {{$t('payment_tax_desc2')}}
          span(style="margin-top:1.8rem") {{$t('payment_tax_desc3')}}
        div(v-else).d-flex.justify-content-center.flex-column.align-items-center.desc-div
          span.mt-4 {{$t('payment_tax_desc3')}}

      template(slot="modal-footer")
        b-btn(size="sm", @click="cancelPay") {{$t('cancel')}}
        b-btn(size="sm", variant="primary", @click="goPay") {{$t('payment')}}
    div.invisible(v-if="payment.show")
      form(:action="`${AppState.Path.pay}/payreq_crossplatform.php`", method="POST", ref="form", target="POPUPW")
        input(type="hidden", name="CST_PLATFORM" :value="AppState.paymentState")
        input(type="hidden", name="CST_MID" value="linkmemine")
        input(type="hidden", name="LGD_CUSTOM_FIRSTPAY" value="")
        input(type="hidden", name="LGD_WINDOW_TYPE" value="iframe")
        input(type="hidden", name="LGD_MERTKEY" value="1d41a901c46c00aabc52e7ba27db73ca")
        input(type="hidden", name="LGD_ENCODING_NOTEURL" value="UTF-8")
        input(type="hidden", name="LGD_WINDOW_TYPE" value="iframe")
        input(type="hidden", name="LGD_OID" :value="payment.timestamp")
        input(type="hidden", name="LGD_AMOUNT" :value="payment.total")
        input(type="hidden", name="CST_PLATFORM" :value="AppState.paymentState")
        input(type="hidden", name="LGD_BUYER" :value="user.name")
        input(type="hidden", name="LMM_BUYERID" :value="user.mgrid")
        input(type="hidden", name="LGD_PRODUCTINFO" :value="payment.items[0].type")
        input(type="hidden", name="LGD_BUYEREMAIL" :value="user.email")
        input(type="hidden", name="LGD_TIMESTAMP" :value="payment.timestamp")
        input(type="hidden", name="LMM_PC_COUNT" :value="payment.items[0].vol")
        input(type="hidden", name="LMM_PK" :value="user.pk")
        input(type="hidden", name="LMM_PRODUCTINFO" :value="payment.items[0].type")
        input(type="hidden", name="LMM_COMPANY_FK" :value="user.company_fk")
        input(type="hidden", name="LMM_WARRANT_START" :value="payment.items[0].start_date | moment('YYYY-MM-DD HH:mm:ss')")
        input(type="hidden", name="LMM_WARRANT_END" :value="payment.items[0].expire_date | moment('YYYY-MM-DD HH:mm:ss')")
        input(type="hidden", name="LMM_UPDATE_PK" :value="payment.items[0].ref")
        input(type="hidden", name="LMM_TERM" :value="payment.items[0].period")
        input(type="hidden", name="LMM_PAY_FLAG" :value="payment.items[0].ref ? 1 : 0")
        input(v-if="useCustom", type="hidden", name="LMM_CUSTOM_PAYMENT" :value="customPaymentName")
</template>

<script>
import _ from 'lodash'
import moment from 'moment-timezone'
import {user, getUserData} from '../../api/access'

const typeValue = {
  Basic: 2500,
  Corporate: 4500
}

export default {
  name: 'license-component',
  methods: {
    goPay () {
      // this.payment.show = false
      this.payment.timestamp = new Date().getTime()
      this.paywin = window.open('about:blank', 'POPUPW', 'width=1024,height=726')
      this.$nextTick(() => { this.$refs.form.submit() })

      if (this.checker) clearInterval(this.checker)
      this.checker = setInterval(() => {
        if (this.paywin.closed) {
          clearInterval(this.checker)
          this.checker = null
          this.paywin = null

          getUserData(null, (err) => {
            if (err) this.$log.error('[REFRESH USER DATA FAILED]')
            this.license = user().license
            this.user = user()
            this.payment.show = false
          })
        }
      }, 500)
    },
    cancelPay () {
      this.payment.show = false
    },
    calcTotal () {
      if (!this.payment.items[0]) return 0
      let t = this.payment.items[0]
      let vol = parseInt(t.vol, 10)
      let value = this.useCustom ? this.customPaymentPrice : typeValue[t.type]
      let total = vol * t.period * value
      let additional = Math.floor(t.period / 12)
      let discount = additional ? (additional + 1) * value * vol : 0
      this.payment.items[0].expire_date = moment(this.payment.items[0].start_date).add(t.period, 'M').format()
      this.payment.discount = discount
      this.payment.fullPay = total
      this.payment.total = total - discount
    },
    addLicense () {
      const date = moment()
      this.payment.title = 'regist_service'
      this.payment.items = [
        {
          ref: null,
          start_date: date.format(),
          expire_date: date.add(1, 'M').format(),
          type: this.license.total.primaryProdType,
          vol: 5,
          period: 1
        }
      ]
      this.calcTotal()
      this.payment.show = true
    },
    updateLicense (t) {
      const isFirst = t.pay_type === 'Free'
      let date = moment(t.pay_expire)
      if (moment().diff(date, 'seconds') > 0) date = moment()
      this.payment.title = 'update_service'
      this.payment.items = [
        {
          ref: t.pay_pk,
          start_date: date.format(),
          expire_date: date.add(1, 'M').format(),
          type: isFirst ? 'Corporate' : t.pay_type,
          vol: t.pay_dev_vol,
          period: 12,
          first: isFirst
        }
      ]
      this.calcTotal()
      this.payment.show = true
    }
  },
  beforeDestroy () {
    if (this.checker) {
      clearInterval(this.checker)
    }
    if (this.paywin && this.paywin.close) {
      this.paywin.close()
    }
  },
  data () {
    const userData = user()
    const useCustom = /.*?\|\d+/.test(userData.custom_payment)
    return {
      checker: null,
      paywin: null,
      fields: [
        {
          key: 'pay_expire',
          label: this.$t('expire_date'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'pay_type',
          label: this.$t('device_type'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'pay_dev_vol',
          label: this.$t('no_devices'),
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'period',
          label: this.$t('period'),
          tdClass: 'text-center',
          thClass: 'text-center'
        },
        {
          key: 'update',
          label: this.$t('renew'),
          tdClass: 'text-center',
          thClass: 'text-center'
        }
      ],
      license: userData.license,
      user: userData,
      useCustom: useCustom,
      customPaymentName: useCustom ? userData.custom_payment.split('|')[0] : null,
      customPaymentPrice: useCustom ? parseInt(userData.custom_payment.split('|')[1]) : null,
      payment: {
        show: false,
        timestamp: 0,
        discount: 0,
        fields: [
          {
            key: 'start_date',
            label: this.$t('start_time'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'expire_date',
            label: this.$t('expire_date'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'type',
            label: this.$t('device_type'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'vol',
            label: this.$t('device'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'period',
            label: this.$t('period'),
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            key: 'total',
            label: this.$t('total_price'),
            // tdClass: 'text-right',
            // thClass: 'text-right'
            tdClass: 'text-center',
            thClass: 'text-center'
          }
        ],
        items: []
      },
      periods: [
        { value: 1, text: `1 ${this.$t('months')}` },
        { value: 2, text: `2 ${this.$t('months')}` },
        { value: 3, text: `3 ${this.$t('months')}` },
        { value: 4, text: `4 ${this.$t('months')}` },
        { value: 5, text: `5 ${this.$t('months')}` },
        { value: 6, text: `6 ${this.$t('months')}` },
        { value: 7, text: `7 ${this.$t('months')}` },
        { value: 8, text: `8 ${this.$t('months')}` },
        { value: 9, text: `9 ${this.$t('months')}` },
        { value: 10, text: `10 ${this.$t('months')}` },
        { value: 11, text: `11 ${this.$t('months')}` },
        { value: 12, text: `12 ${this.$t('months')}` }
        // { value: 24, text: `2 ${this.$t('years')}` },
        // { value: 36, text: `3 ${this.$t('years')}` },
        // { value: 48, text: `4 ${this.$t('years')}` },
        // { value: 60, text: `5 ${this.$t('years')}` }
      ]
    }
  },
  computed: {
    items () {
      let list = this.license.list
      list.sort((a, b) => b.expireTimeStamp - a.expireTimeStamp)
      return _.map(list, v => {
        if (v.isExpired) v._rowVariant = 'active'
        return v
      })
    },
    today () {
      return moment().format()
    }
  }
}
</script>

<style lang="scss" scoped>
.lmm-content-body-padded {
  padding: 0;
  margin: 0;
}

.row, .col, .container-fluid {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.page-header {
  padding: 0 1.5rem 0 1.5rem;
  margin-bottom: 0.5rem;
}

.card {
  border-radius: 0;
  .card-body {
    padding: 0;
  }
}

.btn-secondary {
  color: black !important;
  background-color: #FFFFFF;
  font-weight: 400;
}

.btn-primary {
  color: black;
}

.btn-secondary:hover {
  color: black !important;
  background-color: #F7F7F7 !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

.btn-secondary:active {
  color: black !important;
  background-color: #CBCBCB !important;
  border: 1px solid #9C9C9C !important;
  font-weight: 400;
}

::v-deep .license-table {
  margin: 0;
  tr, td, th {
    padding: 0.5rem 1rem;
    position: relative;
    font-weight: 400;
  }
  th:nth-child(1), th:nth-child(2), th:nth-child(3), th:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    width: 13% !important;
  }
  //th:nth-child(1)::after, th:nth-child(2)::after, th:nth-child(3)::after {
  //  content: "";
  //  position: absolute;
  //  right: 0;
  //  top: 50%;
  //  transform: translateY(-50%);
  //  height: 60%;
  //  border-right: 0.1rem solid #6F6F6F;
  //}
  td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4) {
    position: relative;
    padding-right: 0;
    text-align: left !important;
    color: #6F6F6F;
  }
}

h3 {
  color: #FFFFFF;
  margin-bottom: 0;
  font-weight: 250;
  font-size: 1.5rem;
}

.header-desc-div {
  font-size: 1.2rem;
  font-weight: bold;
}

.desc-div {
  color: #6F6F6F;
}

.discount {
  display: inline-block;
  padding-right: 10px;
  text-decoration: line-through;
  color: #afafaf;
}
</style>
